<div id="academy-courses" class="page-layout simple" (window:resize)="onResize($event)">
    <!-- HEADER -->
    <div class="header primary p-16 p-sm-24" fxLayout="column" fxLayoutAlign="center center">

        <div class="hero-text">
            <!-- <mat-icon [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}" class="hero-icon">school</mat-icon> -->
            <h1 [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
                <!-- WELCOME TO CERTIFY {{origen.infoLanding}} -->
                {{'WIZARD.LANDING.PRODUCTO.RESULTADOS.TITULO' | translate}}
            </h1>
            <h3 [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
                <!-- Our courses will step you through the process of building a small application, or adding a new feature
                  to an existing application. -->
            </h3>
        </div>

    </div>
    <!-- / HEADER -->
    <!-- CONTENT -->
    <div class="content p-24">
      <!-- <mat-horizontal-stepper labelPosition="bottom" #stepper>
        <mat-step >
            <ng-template matStepLabel>{{'WIZARD.LANDING.PRODUCTO.RESULTADOS.STEPS.1' | translate}}</ng-template>
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <img src="./assets/images/norm35/resuTest/1.png" alt="">
              <div class="" fxLayout="row" fxLayoutAlign="start center">
                <button mat-button matStepperNext>Next</button>
              </div>
            </div>
        </mat-step>
        <mat-step >
            <ng-template matStepLabel>{{'WIZARD.LANDING.PRODUCTO.RESULTADOS.STEPS.2' | translate}}</ng-template>
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <img src="./assets/images/norm35/resuTest/2.png" alt="">
              <div class="" fxLayout="row" fxLayoutAlign="start center">
                <button mat-button matStepperNext>Next</button>
                <button mat-button matStepperPrevious>Back</button>
              </div>
            </div>
        </mat-step>
        <mat-step >
            <ng-template matStepLabel>{{'WIZARD.LANDING.PRODUCTO.RESULTADOS.STEPS.3' | translate}}</ng-template>
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <img src="./assets/images/norm35/resuTest/3.png" alt="">
              <div class="" fxLayout="row" fxLayoutAlign="start center">
                <button mat-button matStepperNext>Next</button>
                <button mat-button matStepperPrevious>Back</button>
              </div>
            </div>
        </mat-step>
        <mat-step >
            <ng-template matStepLabel>{{'WIZARD.LANDING.PRODUCTO.RESULTADOS.STEPS.4' | translate}}</ng-template>
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <img src="./assets/images/norm35/resuTest/4.png" alt="">
              <div class="" fxLayout="row" fxLayoutAlign="start center">
                <button mat-button matStepperNext>Next</button>
                <button mat-button matStepperPrevious>Back</button>
              </div>
            </div>
        </mat-step>
        <mat-step >
            <ng-template matStepLabel>{{'WIZARD.LANDING.PRODUCTO.RESULTADOS.STEPS.5' | translate}}</ng-template>
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <img src="./assets/images/norm35/resuTest/5.png" alt="">
              <div class="" fxLayout="row" fxLayoutAlign="start center">
                <button mat-button matStepperNext>Next</button>
                <button mat-button matStepperPrevious>Back</button>
              </div>
            </div>
        </mat-step>
        <mat-step >
            <ng-template matStepLabel>{{'WIZARD.LANDING.PRODUCTO.RESULTADOS.STEPS.6' | translate}}</ng-template>
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <img src="./assets/images/norm35/resuTest/6.png" alt="">
              <div class="" fxLayout="row" fxLayoutAlign="start center">
                <button mat-button matStepperNext>Next</button>
                <button mat-button matStepperPrevious>Back</button>
              </div>
            </div>
        </mat-step>
        <mat-step >
            <ng-template matStepLabel>{{'WIZARD.LANDING.PRODUCTO.RESULTADOS.STEPS.7' | translate}}</ng-template>
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <img src="./assets/images/norm35/resuTest/7.png" alt="">
              <div class="" fxLayout="row" fxLayoutAlign="start center">
                <button mat-button matStepperNext>Next</button>
                <button mat-button matStepperPrevious>Back</button>
              </div>
            </div>
        </mat-step>
        <mat-step >
            <ng-template matStepLabel>{{'WIZARD.LANDING.PRODUCTO.RESULTADOS.STEPS.7' | translate}}</ng-template>
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <img src="./assets/images/norm35/resuTest/8.png" alt="">
              <div class="" fxLayout="row" fxLayoutAlign="start center">
                <button mat-button matStepperNext>Next</button>
                <button mat-button matStepperPrevious>Back</button>
              </div>
            </div>
        </mat-step>
        <mat-step >
            <ng-template matStepLabel>{{'WIZARD.LANDING.PRODUCTO.RESULTADOS.STEPS.8' | translate}}</ng-template>
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <img src="./assets/images/norm35/resuTest/9.png" alt="">
              <div class="" fxLayout="row" fxLayoutAlign="start center">
                <button mat-button matStepperNext>Next</button>
                <button mat-button matStepperPrevious>Back</button>
              </div>
            </div>
        </mat-step>
        <mat-step >
            <ng-template matStepLabel>{{'WIZARD.LANDING.PRODUCTO.RESULTADOS.STEPS.9' | translate}}</ng-template>
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <img src="./assets/images/norm35/resuTest/10.png" alt="">
              <div class="" fxLayout="row" fxLayoutAlign="start center">
                <button mat-button matStepperNext>Next</button>
                <button mat-button matStepperPrevious>Back</button>
              </div>
            </div>
        </mat-step>
        <mat-step >
            <ng-template matStepLabel>{{'WIZARD.LANDING.PRODUCTO.RESULTADOS.STEPS.10' | translate}}</ng-template>
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <img src="./assets/images/norm35/resuTest/11.png" alt="">
              <div class="" fxLayout="row" fxLayoutAlign="start center">
                <button mat-button matStepperPrevious>Back</button>
                <button mat-button (click)="stepper.reset()">Reset</button>
              </div>
            </div>
        </mat-step>
      </mat-horizontal-stepper> -->
  <mat-sidenav-container class="example-container" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
  <mat-sidenav #sidenav mode="side" opened="{{estatus}}" class="example-sidenav"
               [fixedInViewport]="options.value.fixed" [fixedTopGap]="options.value.top"
               [fixedBottomGap]="options.value.bottom">

            <div class="Menu">

            <button mat-flat-button color="{{colorIntroduccion}}" (click)="configuracionMenu(1)"><h1><p>{{'SECCIONES.MENU.INTRODUCCION' | translate}}</p></h1></button> <br>
            <button mat-flat-button color="{{colorGenerales}}" (click)="configuracionMenu(2)"><h1><p>{{'SECCIONES.MENU.GENERALES' | translate}}</p></h1></button> <br>
            <button mat-flat-button color="{{colorNorespondieron}}" (click)="configuracionMenu(3)"><h1><p>{{'SECCIONES.MENU.NO_RESPONDIERON' | translate}}</p></h1></button> <br>

            <!-- Empieza menu de Acontecimientos traumáticos -->
            <button mat-flat-button color="{{colorAcontecimientos}}" (click)="menuAT();configuracionMenu(4);">
            <h1><p>{{'SECCIONES.MENU.ACONTECIMIENTOS_TRAUMATICOS' | translate}}
            <mat-icon>{{iconChangeAT}}</mat-icon>
            </p>
            </h1>
            </button> <br>

             <div class="" *ngIf="showAT">
               <button mat-flat-button color="{{colorRespuestas}}" (click)="configuracionMenu(5)" >
                <h2><p>
                <mat-icon>arrow_right</mat-icon>
                {{'SECCIONES.MENU.AT_RESPUESTAS_ENCUESTA' | translate}}</p></h2>
               </button> <br>

               <button mat-flat-button color="{{colorPresenciaron}}" (click)="configuracionMenu(6)" >
                <h2><p>
                <mat-icon>arrow_right</mat-icon>
                {{'SECCIONES.MENU.SUFRIERON_ACONTECIMIENTO_TRAUMATICO' | translate}}</p></h2>
               </button> <br>

               <button mat-flat-button color="{{colorRequierenAtencion}}" (click)="configuracionMenu(7)" >
                <h2><p>
                <mat-icon>arrow_right</mat-icon>
                {{'SECCIONES.MENU.REQUIEREN_ATENCION_CLINICA' | translate}}</p></h2>
               </button> <br>
             </div>
             <!-- Termina menu de Acontecimientos traumáticos -->

            <!-- Empieza menu de Factores de riegos psicosocial -->
            <button mat-flat-button color="{{colorFactores}}" (click)="menuFRP(); configuracionMenu(8);">
            <h1><p>{{'SECCIONES.MENU.FRP' | translate}}
            <mat-icon>{{iconChangeFRP}}</mat-icon></p>
            </h1>
            </button> <br>

            <div class="" *ngIf="showFRP">
            <button mat-flat-button color="{{colorRespuestasFactores}}" (click)="configuracionMenu(9)">
            <h2><p>
            <mat-icon>arrow_right</mat-icon>
            {{'SECCIONES.MENU.FR_RESPUESTAS_ENCUESTA' | translate}}</p></h2>
            </button> <br>

            <button mat-flat-button color="{{colorResultadosIndividuales}}" (click)="configuracionMenu(10)">
            <h2><p>
            <mat-icon>arrow_right</mat-icon>
            {{'SECCIONES.MENU.RESPUESTAS_INDIVIDUALES' | translate}}</p></h2>
            </button> <br>
            </div>
            <!-- Termina menu de Factores de riegos psicosocial -->

            <!-- Empieza menu de Tableros -->
            <button mat-flat-button color="{{colorTableros}}" (click)="menuTableros(); configuracionMenu(11);">
            <h1><p>{{'SECCIONES.MENU.TABLEROS' | translate}}
            <mat-icon>{{iconChangeTableros}}</mat-icon></p>
            </h1>
            </button> <br>

            <div class="" *ngIf="showTableros">
            <button mat-flat-button color="{{colorGlobal}}" (click)="configuracionMenu(12)">
            <h2><p>
            <mat-icon>arrow_right</mat-icon>
             {{'SECCIONES.MENU.TABLERO_GLOBAL' | translate}}</p></h2>
            </button> <br>

            <button mat-flat-button color="{{colorCategoria}}" (click)="configuracionMenu(13)">
            <h2><p>
            <mat-icon>arrow_right</mat-icon>
             {{'SECCIONES.MENU.TABLERO_CATEGORIA' | translate}}</p></h2>
            </button> <br>

            <button mat-flat-button color="{{colorDominio}}" (click)="configuracionMenu(14)">
            <h2><p>
            <mat-icon>arrow_right</mat-icon>
             {{'SECCIONES.MENU.TABLERO_DOMINIO' | translate}}</p></h2>
            </button> <br>
            </div>
            <!-- Termina menu de Tableros -->

            <button mat-flat-button color="{{colorCalificacion}}" (click)="configuracionMenu(15)"><h1><p>{{'SECCIONES.MENU.CALIFICACIONFINAL' | translate}}</p></h1></button>
            </div>

  </mat-sidenav>

  <mat-sidenav-content class="Sinedav_two" [formGroup]="options">
    <div fxLayout="row" fxLayoutAlign="start center" >
    <button *ngIf="botonMenuEstatus==true" mat-button (click)="sidenav.toggle()">
    <mat-icon >menu</mat-icon>
    </button>
      <h2 [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}" style="font-weight: bold; padding-left:20px;">{{nombreEmpresa}}</h2>
      </div>
    <mat-divider></mat-divider>
    <cdk-virtual-scroll-viewport itemSize="50" class="example-viewport">

    <div *ngIf="introduccion==true">
      <app-introduccion></app-introduccion>
    </div>

    <div *ngIf="generales==true">
      <app-generales
      [productoID]="productoID"
      [centroDeTrabajoId]="centroDeTrabajoId">
    </app-generales>
    </div>

    <div *ngIf="noRespondieron==true">
      <app-no-respondieron
      [productoID]="productoID"
      [centroDeTrabajoId]="centroDeTrabajoId">
      </app-no-respondieron>
    </div>

    <div *ngIf="atRespuestasEncuesta==true">
      <app-at-respuestas-encuesta
      [productoID]="productoID"
      [centroDeTrabajoId]="centroDeTrabajoId">
    </app-at-respuestas-encuesta>
    </div>

    <div *ngIf="sufrieronAcontecimiento==true">
      <app-sufrieron-acontecimiento
      [productoID]="productoID"
      [centroDeTrabajoId]="centroDeTrabajoId">
    </app-sufrieron-acontecimiento>
    </div>

    <div *ngIf="requierenAtencionClinica==true">
      <app-requieren-atencion
      [productoID]="productoID"
      [centroDeTrabajoId]="centroDeTrabajoId">
    </app-requieren-atencion>
    </div>

    <div *ngIf="frpRespuestasEncuesta==true">
      <app-frp-respuestas-encuesta
      [productoID]="productoID"
      [centroDeTrabajoId]="centroDeTrabajoId">
    </app-frp-respuestas-encuesta>
    </div>

    <div *ngIf="frpRespuestasIndividuales==true">
      <app-frp-resultados-individuales
      [productoID]="productoID"
      [centroDeTrabajoId]="centroDeTrabajoId">
    </app-frp-resultados-individuales>
    </div>

    <div *ngIf="tableroGlobal==true">
      <app-tablero-global
      [productoID]="productoID"
      [centroDeTrabajoId]="centroDeTrabajoId">
    </app-tablero-global>
    </div>

    <div *ngIf="tableroCategoria==true">
      <app-tablero-categoria
      [productoID]="productoID"
      [centroDeTrabajoId]="centroDeTrabajoId">
    </app-tablero-categoria>
    </div>

    <div *ngIf="tableroDominio==true">
      <app-tablero-dominio
      [productoID]="productoID"
      [centroDeTrabajoId]="centroDeTrabajoId">
    </app-tablero-dominio>
    </div>

    <div *ngIf="calificacionFinal==true">
      <app-calificacion-final
      [productoID]="productoID"
      [centroDeTrabajoId]="centroDeTrabajoId">
    </app-calificacion-final>
    </div>

    </cdk-virtual-scroll-viewport>

  </mat-sidenav-content>
</mat-sidenav-container>

</div>
<!-- / CONTENT -->
</div>
